import type { SVGProps } from "react";
// generated from User.svg — do not edit manually
// prettier-ignore
export default function User(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 20 C 5.3358 17.523 8.507 16 12 16 C 15.493 16 18.6642 17.523 21 20 M 16.5 7.5 C 16.5 9.985 14.4853 12 12 12 C 9.5147 12 7.5 9.985 7.5 7.5 C 7.5 5.015 9.5147 3 12 3 C 14.4853 3 16.5 5.015 16.5 7.5 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
